

/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NoFileChosen from 'shared/components/NoFileChosen';
import FileChosen from 'shared/components/FileChosen';
import ChangeFile from 'shared/components/ChangeFile';
import ChooseFile from 'shared/components/ChooseCSVFile';
import truncateString from 'utils/truncateString';
import './shceduler-import-view.scss';
import Papa from 'papaparse';
import { connect, useSelector } from 'react-redux';
import ButtonPrimary from 'shared/components/Button/BtnPrimary';
import ButtonSecondary from 'shared/components/Button/BtnSecondary';
import { notification } from 'antd';
import FileError from 'shared/components/FileError';
import FileSuccess from 'shared/components/FileSuccess';
import InviteList from './InviteList';
import InvitedList from './InvitedList';
import { selectEvent} from 'features/EventContainer/redux/reducer/index';
import { handleOverlapTeamSession,handleValidateSchedule,handlePanelTeamAssignment,handleImportSchedule,handleResetImportScheduleModal,handleInviteScheduleList,handleTeamsAssignment,handleInvitePanelList,handleSchedulerBegin,handleSchedulerError,handleSchedulerSuccess } from 'features/EventContainer/redux/actions/exportScheduleActions';
import { OPEN_CEREMONY,CLOSE_CEREMONY} from 'shared/constants/scheduleType';


const ImportScheduler = (props) => {
  const { t } = useTranslation()
  const [fileName, setFileName] = useState('');
  const [invalidImportFile, setInvalidImportFile] = useState(false);
  const [fileUpload, setFileUpload] = useState('noFileChosen');
  const [totalErrors, setTotalErrors] = useState(0);
  
  const Events= useSelector(selectEvent);
  const ExportHeader=Events.eportEventSchedule.ExportHeader;
  const EXPECTED_HEADERS = [
    ExportHeader.eventName,
    ExportHeader.type,
    ExportHeader.date,
    ExportHeader.start_time,
    ExportHeader.end_time,
    ExportHeader.panelName,
    ExportHeader.teamNumber,
    ExportHeader.teamName
  ].map(header => header.trim());


  // eslint-disable-next-line no-unused-vars
  const {validateTeamSession,validateImportedSchedule,validateTeamAssignment,importSchedule, invitedSchedule,ResetImportScheduleModal,csvScheduleImport,
     inviteImportedSchedule,inviteImportedPanel,inviteTeamAssignmentPanel,schedulerBegin,schedulerError,schedulerSuccess, isLoading, successBack,panelBack, reset } = props;
  //const { eventProgramId, is_FLLC_event } = eventDetails
  const {
    successfullyInvited,
    notInvited
  } = csvScheduleImport;

  const getVolunteersFromFile = (fileResults) => {

    let errorCount = 0;
    if (fileResults.length > 0) {
     
      schedulerBegin();
      const uploadedSchedule = fileResults.map((schedule, i) => {
        const lineNumber = i + 2;
        let updatedData = {};
        let errors = [];

        //rename schedule property
        let data={
          eventName:schedule[ExportHeader.eventName],
          id:'',
          scheduleId:'',
          panelId:'',
          eventType:'',
          type:schedule[ExportHeader.type].trim(),
          date:schedule[ExportHeader.date],
          startTime:schedule[ExportHeader.start_time],
          endTime:schedule[ExportHeader.end_time],
          panelName:schedule[ExportHeader.panelName].trim(),
          teamNumber:schedule[ExportHeader.teamNumber].trim(),
          teamName:schedule[ExportHeader.teamName].trim(),
          isSessionChanged:true,
          isNewPanelAdded:true,
          isPanelDetailChanged:true,
          
        }
       
        validateImportedSchedule(t, data, lineNumber, (error) => {

          if (Array.isArray(error)) {
            errors.push(...error);
          } else {
            errors.push(error);
          }
          errorCount += errors.length;
        },(newData) => {
          updatedData={...newData}        
          
        },
      );

        return {
          ...updatedData,
          newId: i + 1,
          errors
        }
      })

      //checking for duplicate entries
      uploadedSchedule.reduce((acc, current) => {
        const matchfound = acc.find(item => item.eventName === current.eventName &&
              item.type === current.type && item.date === current.date &&
              item.startTime === current.startTime && item.endTime === current.endTime &&
              item.panelName === current.panelName && item.teamNumber === current.teamNumber &&
              item.teamName === current.teamName);
        if (!matchfound) {       
          return acc.concat([current]);
        } else {
          //if duplicate found, add error to the schedule
          errorCount++;
          current.errors.push({message: t('schedulerDuplicateRowErrorLable', { '0': current.type, '1': current.newId+1, '2': matchfound.newId+1 })});
        }
        return acc;
      }, []);

       //validate one team session with other session of same team
       //before schedule conflict validation check if any data validation error is present
       //if data validation error is present, then skip the schedule conflict validation
       const isErrorFree = uploadedSchedule.every(session => session.errors.length <= 0);
      if (isErrorFree) {
        uploadedSchedule.forEach((prevSession, idx) => {
          if (
            prevSession.type !== OPEN_CEREMONY &&
            prevSession.type !== CLOSE_CEREMONY
          ) {
            // Compare with all other sessions for the same team
            uploadedSchedule.forEach((newSession, otherIdx) => {
              if (
                idx !== otherIdx &&
                newSession.teamName === prevSession.teamName &&
                newSession.teamNumber === prevSession.teamNumber &&
                newSession.type !== OPEN_CEREMONY &&
                newSession.type !== CLOSE_CEREMONY 
                && newSession.errors.length <= 0
              ) {

                validateTeamSession(t,prevSession, newSession, (Errors) => {
                  if (Errors.length > 0) {
                    Errors.forEach((error) => {
                      errorCount++;
                    });
                    newSession.errors.push(...Errors);
                  }
                });
              }
            });
          }
        });  
      }

      importSchedule(uploadedSchedule);

      setTimeout(() => {
        if(errorCount > 0) {
          schedulerError();
        }
        else
        {
          schedulerSuccess();
        }
        
      }, 100);
 
    }
    setTotalErrors(errorCount);
    
  }

  const isValidTemplate = (headers) => {
    if (headers.length < EXPECTED_HEADERS.length) {
      return false
    }

    for (let i = 0; i < EXPECTED_HEADERS.length; i += 1) {
      // Check if the header matches the expected header
      if (headers[i]!== EXPECTED_HEADERS[i]) return false
    }

    return true;
  }


  const onChange = (args) => {
    const { file } = args;
    ResetImportScheduleModal();
    if (file.status !== 'uploading') {
        setFileName(truncateString(file.name, 65))

      if(file.type == 'text/csv') {      
    
      setFileUpload('importReady');

      Papa.parse(file.originFileObj, {
        download: true,
        header: true,
        skipEmptyLines: 'greedy',
        complete: (results) => {
          // error handling for when the upload csv file does not match the expected headers
          const headers = results.meta.fields;
          const validHeaders = isValidTemplate(headers);
          if (validHeaders) {

            if (results.data.length === 0) {
              setFileUpload('emptyFile');
               setInvalidImportFile(true);
            } else {
              getVolunteersFromFile(results.data);
              setInvalidImportFile(false);
              setFileUpload('importReady');
            } 
          }
          if (!validHeaders) {
            setInvalidImportFile(true);
            setFileUpload('importError');
          }

        }
      });
      }
      else 
      {         
        setFileUpload('invalidImportFile');
        setInvalidImportFile(true);
      }
    }
  }

  const handleImport = () => {
    if (totalErrors > 0) {
      setFileUpload('inviteError')
    }
    if (totalErrors === 0) {
      setFileUpload('inviteReady');    
    }
  }

  useEffect(() => {
    const sett=reset;
    resetTab();
  },[reset])

  const resetTab = () => {
    setFileName('');
    setFileUpload('noFileChosen');
    setTotalErrors(0);
    ResetImportScheduleModal();
  }

  const renderFileUploadField = () => {
    switch (fileUpload) {
      case 'importReady':
        return <NoFileChosen text={t('readyForImportLabel', { '0': fileName })} />;
      case 'invalidImportFile':
        return <FileError text={t('schedulerInvalidFileTypeLabel', { '0': fileName })} />;
      case 'emptyFile':
        return <FileError text={t('schedulerFileNoContentLabel')} />;
      case 'importError':
        return <FileError text={t('headersDontMatchTemplateLabel')} />;     
      case 'inviteReady':
        return <FileChosen text={t('schedulerReadyToUpdateLabel', { '0': fileName })} />;
      case 'inviteError':
        return <FileError text={t('fileErrorsLabel', { '0': fileName, '1': totalErrors })} />;
      case 'noFileChosen':
        return <NoFileChosen />;
      case 'inviteSuccess':
        return <FileSuccess text={t('schedulerSuccessHeaderLabel', { '0': fileName })} />;
      default:
        return null;
    }
  }

  const renderInviteList = () => {
    switch (fileUpload) {
      case 'importReady':
        return null;
      case 'noFileChosen':
        return null;
      case 'importError':
      case 'invalidImportFile':
      case 'emptyFile':
        return null;
      case 'inviteSuccess':
        return <InvitedList scheduleInvited={successfullyInvited} scheduleNotInvited={notInvited} />;     
      default:
        return <InviteList errors={Boolean(totalErrors)} schedules={invitedSchedule} />;
      
    }
  }

  const renderChangeFileBtn = () => {

    if (fileUpload === 'importReady' || fileUpload === 'invalidImportFile' || fileUpload === 'emptyFile' || fileUpload === 'importError' || fileUpload === 'inviteReady' || fileUpload === 'inviteError') {
      return (
        <ChangeFile onChange={onChange} />
      )
    }
    return null;
  } 

  function hasPanelCreated(updatedInvitedSchedule) {
    return !!updatedInvitedSchedule.find(session =>
      session.isNewPanelAdded === true);
  }

  function hasPanelDetailUpdated(updatedInvitedSchedule) {
    return !!updatedInvitedSchedule.find(session => 
      session.isPanelDetailChanged === true 
    );
  }
  
  function hasSessionChanged(updatedInvitedSchedule) {
    return !!updatedInvitedSchedule.find(session => 
      session.isSessionChanged === true );
  }

  const updateTeamAssignment = () => {
    const updatedSession = invitedSchedule.map((schedule) => {
      let updatedSchedule = {};
      validateTeamAssignment(schedule,(newSchedule) => {
        updatedSchedule={...newSchedule}        
        
      },
    );

      return {
            ...updatedSchedule
      };
    });

    return updatedSession;
   
  }

  const successCallback = () => {

    setFileUpload('inviteSuccess');
    schedulerSuccess();
    successBack();
    panelBack();

  }
  
  const updateAssignmentCallback = () => { 
    panelBack();
    setTimeout(() => {
       //invite scheduler session
       if(hasSessionChanged(invitedSchedule)) {     
        inviteImportedSchedule(successCallback);
      }
      else
      {
        schedulerSuccess();
        setFileUpload('inviteSuccess');
      }
     },500)  
  }

  const newPanelAddedCallback = () => {
    schedulerSuccess();
    panelBack();
    setTimeout(() => {
        //check if team assignment is updated
        const updatedSchedulePanel= updateTeamAssignment();
        if(hasPanelDetailUpdated(updatedSchedulePanel)) {
          importSchedule(updatedSchedulePanel);
          inviteTeamAssignmentPanel(updateAssignmentCallback);
        }             
    },2000)
  }

  
  const handleInvite = () => {
    if (totalErrors > 0) {
      setFileUpload('inviteError');
      return;
    }
    let hasChangeDetected=false;

    schedulerBegin();

    // check if panel created
    if(hasPanelCreated(invitedSchedule)) {   
      hasChangeDetected=true;  
      //add new panel assignment
      inviteImportedPanel(newPanelAddedCallback);
    }
    else 
    {
      //check if team assignment is updated
      const updatedSchedulePanel= updateTeamAssignment();
      if(hasPanelDetailUpdated(updatedSchedulePanel)) {
        hasChangeDetected=true;
       importSchedule(updatedSchedulePanel);
       inviteTeamAssignmentPanel(updateAssignmentCallback);
      }
      else
      {
        //invite scheduler session
        if(hasSessionChanged(invitedSchedule)) {   
          hasChangeDetected=true;  
          inviteImportedSchedule(successCallback);
        }
        else
        {
          if (!hasChangeDetected) {
            notification.success({
              message: 'Success',
              description: `Schedule complete: No updates detected!`,
            });
          }
          schedulerSuccess();

        }
        
      }          
    }
  }

  const renderFileUploadBtn = () => {
   
    switch (fileUpload) {
      case 'noFileChosen':
        return <ChooseFile onChange={onChange} />;
      case 'importReady':
        return <ButtonSecondary disabled={invalidImportFile} loading={isLoading} onClick={handleImport} additionalClassNames='btn--180'>{t('importLabel')}</ButtonSecondary>;
      case 'importError':
      case 'invalidImportFile':
      case 'emptyFile':
        return <ButtonSecondary disabled={invalidImportFile} loading={isLoading} onClick={handleImport} additionalClassNames='btn--180'>{t('importLabel')}</ButtonSecondary>;     
      case 'inviteReady':
        return <ButtonPrimary loading={isLoading} additionalClassNames='btn--180' onClick={handleInvite}>{t('schedulerSetBtnLabel')}</ButtonPrimary>;
      case 'inviteError':
        return <ButtonSecondary loading={isLoading} additionalClassNames='btn--180' onClick={resetTab}>{t('schedulerResetBtnLabel')}</ButtonSecondary>;
  
      default:
        return null;
    }
  }


  return (
    <div className='import'>
      <div className='import__row'>
        {renderFileUploadField()}
        <span className='import__choose-file'>
          {renderFileUploadBtn()}
        </span>
      </div>
      {renderChangeFileBtn()}
      {renderInviteList()}
    </div>
  );

};

ImportScheduler.propTypes = {
  validateImportedSchedule: PropTypes.func.isRequired,
  validateTeamAssignment: PropTypes.func.isRequired,
  invitedSchedule: PropTypes.array.isRequired,
  ResetImportScheduleModal: PropTypes.array.isRequired,
  eventRoleTypes: PropTypes.array.isRequired,
  importSchedule: PropTypes.func.isRequired,
  inviteImportedSchedule: PropTypes.func.isRequired,
  inviteImportedPanel: PropTypes.func.isRequired,
  inviteTeamAssignmentPanel: PropTypes.func.isRequired,
  schedulerBegin: PropTypes.func.isRequired,
  schedulerError: PropTypes.func.isRequired,
  schedulerSuccess: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  csvScheduleImport: PropTypes.object.isRequired,
  successBack: PropTypes.func.isRequired,
  panelBack: PropTypes.func.isRequired,
  reset: PropTypes.bool,
  validateTeamSession:PropTypes.func.isRequired,
};

ImportScheduler.defaultProps = {
  isLoading: false
}

function mapStateToProps(state) {
  const { event: { eventDetails, eportEventSchedule } } = state;

  const {addScheduleImportList,csvScheduleImport,isLoadingSchedule} = eportEventSchedule;

  return {
    eventDetails,
    invitedSchedule: addScheduleImportList,
    isLoading: isLoadingSchedule,
    csvScheduleImport
  }
}

const mapDispatchToProps = {
  importSchedule: handleImportSchedule,
  validateImportedSchedule: handleValidateSchedule,
  validateTeamAssignment: handlePanelTeamAssignment,
  ResetImportScheduleModal:handleResetImportScheduleModal,
  inviteImportedSchedule: handleInviteScheduleList,
  inviteImportedPanel: handleInvitePanelList,
  inviteTeamAssignmentPanel:handleTeamsAssignment,
  schedulerBegin: handleSchedulerBegin,
  schedulerError: handleSchedulerError,
  schedulerSuccess: handleSchedulerSuccess,
  validateTeamSession:handleOverlapTeamSession

}

export default connect(mapStateToProps, mapDispatchToProps)(ImportScheduler);